module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_personal_policy", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"PersonalTitle","data-fox-context":"personal"},[["textNode",{"text":"Personal Data Policy"}]]]]],["div",{"data-fox-alias":"personalText","class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/personal.tpl
// module id = 1239
// module chunks = 4